import React from "react";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import TextFieldsIcon from "@material-ui/icons/TextFields";

interface Props {
  id: string;
  label: string;
  type?: string;
  value: string;
  onChange: (value: string) => void;
  required: boolean;
  icon?: React.ReactNode;
  validator?: (value: string) => Error | null;
}

const ZakatTextField = ({
  id,
  label,
  value,
  onChange,
  validator,
  type = "text",
  required = true,
  icon = <TextFieldsIcon />,
}: Props) => {
  const onUpdate = (evt: React.ChangeEvent<HTMLInputElement>) => {
    onChange(evt.target.value);
  };

  let err: Error | null = null;
  let hasError = false;
  let errMessage: string = "";

  if (validator) {
    err = validator(value);
    hasError = err !== null;
    errMessage = err !== null ? err.message : "";
  }

  return (
    <TextField
      type={type}
      error={hasError}
      helperText={errMessage}
      required={required}
      id={id}
      name={id}
      label={label}
      fullWidth
      value={value}
      onChange={onUpdate}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">{icon}</InputAdornment>
        ),
      }}
    />
  );
};

export default ZakatTextField;
